import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createLab",
    serviceName: "auth",
    query: gql`
      mutation createLab(
        $id: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $email: String
        $title: String
        $address: String
        $site_url: String
        $tellphone: String
        $postal_code: String
        $register_date: String
        $registered_number: String
        $national_identifier: String
        $details: String
      ) {
        createLab(
          id: $id
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          title: $title
          email: $email
          address: $address
          site_url: $site_url
          tellphone: $tellphone
          postal_code: $postal_code
          register_date: $register_date
          registered_number: $registered_number
          national_identifier: $national_identifier
          details: $details
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
